export const apiName: string = 'tipos-materiais';


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material/material-tipos/shared/data.service.ts
 **/